<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <c-form>
                    <c-form-item type="select" label="所属模块" name="classify" options="CLASSIFY_TOPIC" ></c-form-item>
                    <c-form-item type="input" label="话题标题" name="title"></c-form-item>
                    <c-form-item type="datetime" label="发布时间" start-name="start_date" end-name="end_date"></c-form-item>
                    <c-form-item type="input" label="创建人" name="user_name"></c-form-item>
                    <c-form-item type="select" label="是否置顶" name="is_top" :options="topState"></c-form-item>
                    <c-form-item type="select" label="是否隐藏" name="is_valid" :options="validState"></c-form-item>
                </c-form>
            </m-search>

            <m-operate>
                <c-button power="b_moments_topic_edit" color="sys" @click="navigateTo('/moments_topic_add')">新建话题</c-button>
                <c-button power="b_moments_topic_edit" color="black" hollow @click="updateValid('batch', 1)">批量显示</c-button>
                <c-button power="b_moments_topic_edit" color="black" hollow @click="updateValid('batch', 0)">批量隐藏</c-button>
                <c-button power="b_moments_topic_edit" color="black" hollow @click="updateDelete()">批量删除</c-button>
            </m-operate>

            <c-table ref="table">

                <c-table-column
                        type="selector"
                ></c-table-column>

                <c-table-column
                        label="所属模块"
                        name="classify_name"
                        width="100"
                ></c-table-column>

                <c-table-column
                        label="话题标题"
                        name="title"
                        width="200"
                ></c-table-column>

                <c-table-column
                        label="跟帖数"
                        name="detail_count"
                        width="80"
                >
                    <template v-slot="row">
                        <span v-if="row.data.detail_count > 0">
                            <a class="s-link" @click="navigateTo(`/moments_topic_follow?topic_id=${row.data.id}`)">
                                &nbsp;{{row.data.detail_count}} &nbsp;
                            </a>
                        </span>
                        <span v-else>0</span>
                    </template>
                </c-table-column>
                <c-table-column
                        label="浏览量"
                        name="pv"
                        width="80"
                ></c-table-column>

                <c-table-column
                        label="是否置顶"
                        name="is_top"
                        width="80"
                >
                    <template v-slot="row">
                        <c-switch :value="row.data.is_top == 1" text="是,否" @change="updateTop(row, arguments[0], arguments[1])"></c-switch>
                    </template>
                </c-table-column>

                <c-table-column
                  label="置顶时间"
                  name="top_date"
                  width="150"
                >
                  <template v-slot="row">
                    <span v-if="row.data.is_top == 1 && row.data.top_date">{{row.data.top_date}}</span>
                    <span v-else>--</span>
                  </template>
               </c-table-column>

                <c-table-column
                        label="显示隐藏"
                        name="is_valid"
                        width="80"
                >
                    <template v-slot="row">
                        <c-switch :value="row.data.is_valid == 1" text="显示,隐藏" @change="updateValid(row, arguments[0], arguments[1])"></c-switch>
                    </template>
                </c-table-column>

                <c-table-column
                        label="创建人"
                        name="user_name"
                        width="150"
                >
                </c-table-column>

                <c-table-column
                        label="发布时间"
                        name="create_date"
                        width="140"
                >
                </c-table-column>

                <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
                        width="200"
                >
                    <template v-slot="row">
                        <c-table-button power="b_moments_topic_view" @click="navigateTo(`/moments_topic_follow?topic_id=${row.data.id}`)">查看话题跟帖</c-table-button>
                        <c-table-button power="b_moments_topic_view" @click="navigateTo(`/moments_topic_detail/${row.data.id}`)">话题详情</c-table-button>
                        <c-table-button power="b_moments_topic_edit" @click="navigateTo(`/moments_topic_edit/${row.data.id}`)">修改</c-table-button>
                        <c-table-button power="b_moments_topic_edit" @click="updateDelete(row.data)">删除</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
        </module>

    </page>
</template>

<script>
    export default {
        name: 'm_moments_note',

        data() {
            return {
                state: [ {
                    name: '未审核',
                    value: 1
                }, {
                    name: '已审核',
                    value: 2
                }, {
                    name: '驳回',
                    value: -1
                }],
                recommendState: [{
                    name: '不推荐',
                    value: '0'
                }, {
                    name: '推荐',
                    value: '1'
                }
                ],
                topState: [{
                    name: '不置顶',
                    value: '0'
                }, {
                    name: '已置顶',
                    value: '1'
                }
                ],
                validState: [{
                    name: '隐藏',
                    value: '0'
                }, {
                    name: '显示',
                    value: '1'
                }
                ]
            }
        },

        computed: {
            stateText() {
                var state = {};
                this.state.forEach(item => {
                    state[item.value] = item.name;
                });

                return state;
            }
        },

        mounted() {
            this.$refs.search.search();
            this.$bus.$on('momentsTopicList.update', () => {
                this.$refs.search.search();
            });

        },

        methods: {
            searchHandle(data) {
                data.moments_type = 3; // 话题管理
                data.ref_moments_id = 0; //关联ID
                this.$refs.table.load({
                    url: '/moments/list',
                    data
                });
            },

            updateRecommend(item, state, stop) {
                stop();
                this.$confirm({
                    text: '确定要' + (state ? '推荐' : '取消推荐') +'【' + item.data.title + '】吗？',
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: '/moments/edit_recommend_state',
                            data: {
                                id: item.data.id,
                                is_recommend: state,
                            },
                            loading: true,
                            success: data => {
                                this.$message({
                                    text: '操作成功',
                                    icon: 'success'
                                });
                                this.$refs.table.update();
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
            },

            updateValid(item, state, stop) {
                var list = item == 'batch' ? this.$refs.table.getRow('selected') : [item];
                stop && stop();

                if (!list.length) {
                    this.$message({
                        text: '请选择要操作的内容'
                    });
                    return;
                }

                this.$confirm({
                    text: '确定要' + (state ? '显示' : '隐藏') + (item == 'batch' ? '所选' : '该') +'内容吗？',
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: '/moments/batch_edit_valid_state',
                            data: {
                                ids: Array.from(list, item => item.data.id),
                                is_valid: state ? 1 : 0
                            },
                            loading: true,
                            success: data => {
                                this.$message({
                                    text: '操作成功',
                                    icon: 'success'
                                });
                                this.$refs.table.update();
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
            },

            updateDelete(item) {
                var list = item ? [{
                    data: item
                }] : this.$refs.table.getRow('selected');
                if (!list.length) {
                    this.$message({
                        text: '请选择要操作的内容'
                    });
                    return;
                }

                this.$confirm({
                    text: '确定要删除'+ (item ? '该' : '所选') +'内容吗？',  // 提示内容,
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: '/moments/batch_delete',
                            data: {
                                ids: Array.from(list, item => item.data.id),
                                is_delete:1
                            },
                            loading: true,
                            success: data => {
                                this.$message({
                                    text: '操作成功',
                                    icon: 'success'
                                });
                                this.$refs.table.update();
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
            },
            updateTop(item, state, stop) {
                stop();
                this.$confirm({
                    text: '确定要'+(state ? '置顶' : '取消置顶')+'【'+item.data.title+'】吗？',  // 提示内容,
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: '/moments/edit_top_state',
                            data: {id:item.data.id,is_top:state},
                            loading: true,
                            success: data => {
                                this.$message({
                                    text: '操作成功',
                                    icon: 'success'
                                });
                                this.$refs.table.update();
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
            },
        }
    }
</script>